import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  Container,
  Label,
  Form,
  TextField,
  TextareaField,
  SelectField,
  Button,
  FilteredListField,
  TagField,
  FormattedField,
} from '../common';

export default function EntityForm({
  show, values: formValues, onClose, onSave, staffMembers, serviceCategories,
}) {
  if (!show) {
    return null;
  }
  const time = moment.utc(moment.duration(formValues.duration).asMilliseconds()).format('HH:mm').split(':');
  return (
    <Container
      onClose={onClose}
      style={{
        position: 'absolute',
        top: 60,
        right: 0,
        width: 500,
      }}
    >
      {Object.keys(formValues).length
        ? (
          <Label
            type="title"
          >Edit Service {formValues.name}</Label>
        )
        : (
          <Label
            type="title"
          >Add New Service</Label>
        )}
      <Form
        values={{
          ...formValues,
          hours: time[0],
          mins: time[1],
        }}
        validate={(touched, values) => {
          const errors = {};
          if (!values.name) {
            errors.name = 'Shouldn\'t be empty';
          }
          if (!values.hours) {
            errors.hours = 'Shouldn\'t be empty';
          }
          if (!values.mins) {
            errors.mins = 'Shouldn\'t be empty';
          }
          if (!values.staff_ids || values.staff_ids.length === 0) {
            errors.staff_ids = 'Select one at least';
          }
          Object.keys(touched).forEach((field) => {
            if (field === 'hours' && (values.hours > 24 || values.hours < 0)) {
              errors.hours = 'Invalid interval';
            }
            if (field === 'mins' && (values.mins > 60 || values.mins < 0)) {
              errors.mins = 'Invalid interval';
            }
          });
          return errors;
        }}
      >{({ values, getHandler, errors, hasErrors }) => {
        return (
          <div>
            <div>
              <TextField
                style={{ width: '100%' }}
                label="Service Name"
                value={values.name || ''}
                onChange={getHandler('name')}
                error={errors.name}
              />
            </div>
            <div>
              <SelectField
                style={{ width: '100%' }}
                value={values.category}
                onChange={getHandler('category')}
                label="Category"
                options={serviceCategories.find((s) => {
                  return s.value.toLowerCase() ===
                  (values.category || serviceCategories[0].value).toLowerCase();
                })
                  ? serviceCategories
                  : [{
                    value: values.category,
                    label: values.category,
                  }, ...serviceCategories]}
                error={errors.category}
              />
            </div>
            <div>
              <Label
                type="form"
                style={{
                  display: 'inline-block',
                  marginTop: 23,
                  verticalAlign: 'top',
                }}
              >
                Service Duration:
              </Label>
              <FormattedField
                style={{ width: '30%', paddingRight: 5 }}
                label="Hrs"
                value={values.hours || ''}
                onChange={getHandler('hours')}
                error={errors.hours}
              />
              <FormattedField
                style={{ width: '30%', paddingLeft: 5 }}
                label="Mins"
                value={values.mins || ''}
                onChange={getHandler('mins')}
                error={errors.mins}
              />
            </div>
            <div>
              <TextareaField
                count
                max={160}
                style={{ width: '100%' }}
                label="Description"
                value={values.description || ''}
                onChange={getHandler('description')}
              />
            </div>
            <div>
              <TagField
                style={{ width: '100%' }}
                label="Tags"
                value={values.tags}
                onChange={getHandler('tags')}
              />
            </div>
            <div>
              <FilteredListField
                style={{ width: '100%' }}
                label="Staff who offer this service"
                value={values.staff_ids}
                error={errors.staff_ids}
                onChange={getHandler('staff_ids')}
                serialize={(staffMember) => {
                  return `${staffMember.id}`;
                }}
                options={staffMembers}
              >
                {(staffMember) => {
                  return `${staffMember.first_name} ${staffMember.last_name}`;
                }}
              </FilteredListField>
            </div>
            <div
              style={{ marginTop: 30 }}
            >
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  if (!hasErrors) {
                    onSave(values);
                    onClose();
                  }
                }}
                disabled={hasErrors}
                type="primary"
              >Save</Button>
            </div>
          </div>
        );
      }}</Form>
    </Container>
  );
}

EntityForm.propTypes = {
  show: PropTypes.bool.isRequired,
  values: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape()]),
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  staffMembers: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  serviceCategories: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })).isRequired,
};

EntityForm.defaultProps = {
  values: {},
};
